import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { AppNotification } from "@/model/data/notifications/AppNotification";
import { OneTimeCodeNotification } from "@/model/data/notifications/OneTimeCodeNotification";
import { SecurityNotification } from "@/model/data/notifications/SecurityNotification";
import { UpdateResultNotification } from "@/model/data/notifications/UpdateResultNotification";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class FetchPaginatedNotificationsResData extends ApiGenericResponse {
    notifications: Array<AppNotification>;
    distinctDevices: Array<string>;
    paginatedTotalItems: number;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Notifications) {
            this.notifications = new Array<AppNotification>();
            obj.Notifications.forEach((element) => {
                let n = null;
                if (NotificationTypesEnum[element.NotificationType] == NotificationTypesEnum[NotificationTypesEnum.Update]) n = new UpdateResultNotification(element);
                else if (NotificationTypesEnum[element.NotificationType] == NotificationTypesEnum[NotificationTypesEnum.Security]) n = new SecurityNotification(element);
                else if (NotificationTypesEnum[element.NotificationType] == NotificationTypesEnum[NotificationTypesEnum.OneTimeCode]) n = new OneTimeCodeNotification(element);
                this.notifications.push(n);
            });
        }

        if (obj.DistinctDevices) {
            this.distinctDevices = new Array<string>();
            obj.DistinctDevices.forEach((element) => {
                this.distinctDevices.push(element);
            });
        }

        if (obj.PaginatedTotalItems != null && obj.PaginatedTotalItems != undefined) this.paginatedTotalItems = obj.PaginatedTotalItems;
    }
}
